/* eslint-disable max-len */
import {
    Heading,
    HStack, IconButton, Spinner, Text, VStack,
} from '@chakra-ui/react';
import { ComponentProps } from 'react';
import { FaIcon } from '@acp/core-ui';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { CardLayout } from './card-layout';
import { useSettingsUpdate } from '../../settings/hooks/use-settings-update';

function QldAutoIbtBanner(props: ComponentProps<typeof HStack>) {
    const updateMutation = useSettingsUpdate();

    const handleHideBanner = () => {
        updateMutation.update(
            { user: { hasDismissedQldAutoIbtBanner: true }, agency: {} }
        );
    };

    return (
        <CardLayout {...props} gap={2} px={8} py={8} bgColor="secondary.500" color="white" pos="relative">
            <IconButton
                onClick={handleHideBanner}
                variant="ghost"
                colorScheme="muted"
                aria-label="menu"
                icon={updateMutation.isPending ? <Spinner size="sm" color="muted.400" /> : <FaIcon icon={faXmark} />}
                isDisabled={updateMutation.isPending}
                position="absolute"
                size="md"
                color="muted.200"
                right={3}
                top={3}
                _hover={{
                    color: 'white',
                    bgColor: 'transparent',
                }}
                _active={{
                    bgColor: 'transparent',
                }}
            />
            <CardLayout.Body flexDir={['column', null, 'row']}>
                <VStack alignItems="start">
                    <Heading color="white" fontSize="xl" fontWeight="500" mb={2}>
                        Work order automation is here!
                    </Heading>
                    <Text fontSize="sm" color="charcoal.50" pr={[0, null, 14]}>
                        No manual work order requests are required, no lease dates to monitor or track, just seamless processing using live data from your Property Me / Property Tree software.
                        <br />
                        If you&apos;d like to take advantage of Work Order Automation, simply contact your Account Manager to opt-in today.
                    </Text>
                </VStack>
            </CardLayout.Body>
        </CardLayout>
    );
}

export { QldAutoIbtBanner };
